import React from 'react';
import { Box, Typography } from '@mui/material';

class ErrorBoundary extends React.Component {
  state = { hasError: false, error: null };

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  render() {
    if (this.state.hasError) {
      return (
        <Box sx={{ p: 3, bgcolor: '#ffebee', borderRadius: 1 }}>
          <Typography color="error">Something went wrong: {this.state.error?.message}</Typography>
          <Typography variant="caption">Please refresh or contact support.</Typography>
        </Box>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;